<template>
  <!--prettier-ignore-->
  <div class="tw-bg-secondary-500 tw-py-2 tw-text-center tw-text-white tw-text-xs">
    You are browsing as a <strong>Mentee</strong>.
    <button @click="switchActor" class="tw-underline tw-decoration-dashed tw-underline-offset-2 tw-rounded-md tw-p-0.5 tw--m-0.5 focus:tw-outline-none focus-visible:tw-ring focus:tw-ring-neutral-200">Switch to Mentor here</button>
  </div>
</template>

<script setup>
import { router } from '@inertiajs/vue3'

const switchActor = () => {
  router.patch('/switch-actor')
}
</script>
